<template>
  <div class="subtitles-parent" :class="{'user-active':userActive}">
      <span v-for="(text,i) in cueTexts" :key="i" class="cue-text">{{text}}</span>
  </div>
</template>

<script>
export default {
 props:{
    cueTexts:{
         type:Array,
         required:true       
    },
    userActive:{
        type:Boolean,
        default:false,
    }
 }
}
</script>

<style lang="scss" scoped>
@import '@video/src/scss/_mixins.scss';
@import '@video/src/scss/_variables.scss';

.subtitles-parent{
    @include flex($flow:column nowrap);
    position:absolute;
    bottom:1rem;
    left:50%;
    transform:translateX(-50%);
    width:$controls-width;
    &.user-active{
    bottom: $control-bar-height;
    }
    .cue-text{
        font-size:1.5rem;
        color:white;
        background:rgba(0,0,0,0.2);
        padding:0 0.5em;
        white-space: pre-line;
        text-align: center;
    }
}
</style>